import { useState } from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const KEY = "avter-cerez-bildirimi";
const readDismissed = () => {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
};

export const CookieBanner = () => {
  const site = useSite();
  const [hidden, setHidden] = useState(readDismissed);
  const notice = site.cookie_notice;
  if (hidden || !notice) return null;

  const dismiss = () => {
    try {
      window.localStorage.setItem(KEY, "1");
    } catch {
      /* storage unavailable */
    }
    setHidden(true);
  };

  return (
    <div role="region" aria-label="Çerez bildirimi" className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white shadow-[0_-8px_24px_rgba(15,23,42,0.08)]" data-testid="cookie-banner">
      <div className="container-site flex items-center justify-between gap-4 py-3 sm:py-4">
        <p className="text-sm text-ink-soft sm:text-[15px]" data-testid="cookie-banner-text">
          {notice.text}{" "}
          <Link to={notice.link_to} className="font-semibold text-navy underline" data-testid="cookie-policy-link">{notice.link_label}</Link>
        </p>
        <button type="button" onClick={dismiss} className="h-10 shrink-0 rounded-md bg-navy px-5 font-semibold text-white transition-colors hover:bg-navy-700 sm:h-11 sm:px-6" data-testid="cookie-accept-btn">
          {notice.button_label}
        </button>
      </div>
    </div>
  );
};
